import { Component, OnInit } from '@angular/core';
import { CreateOrderDto, Order, OrderWithGamas } from '../../../models/Order';
import { DateService } from '../../../services/date.service';
import { OrderService } from '../../../services/entities/order.service';
import { CreateGamaDto, Gama } from '../../../models/Gama';
import { GamaService } from '../../../services/entities/gama.service';
import { PdfService } from '../../../services/pdf.service';

@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrl: './orders-list.component.scss'
})
export class OrdersListComponent implements OnInit{

  constructor(public dateService: DateService,
              private orderService: OrderService,
              private gamaService: GamaService,
              private pdfService: PdfService){}

  //Modal Vars
  modal: boolean = false
  modal_delete_checkbox: boolean = false
  delete_order: OrderWithGamas = {id: '', number: '', gamas: []}

  //Orders Vars
  orders: OrderWithGamas[] = []

  async ngOnInit() {
    this.orders = (await this.orderService.getAllOrders().toPromise())!!
    this.sortOrders()
  }

  sortOrders(){
    this.orders = this.orders.sort((a, b) => new Date(b.creation_date!!).getTime() - new Date(a.creation_date!!).getTime())
  }

  getActiveGamas(order: OrderWithGamas){
    return order.gamas.filter(gama => gama.active === true)
  }

  cloneOrder(order: OrderWithGamas){
    const order_with_gamas_aux: Partial<OrderWithGamas> = {...order}
    delete order_with_gamas_aux.id
    delete order_with_gamas_aux.gamas

    this.orderService.createOrder(order_with_gamas_aux as CreateOrderDto).subscribe(
      new_order => {
        this.orders.push(new_order)

        const duplicated_gamas: Partial<CreateGamaDto>[] = order.gamas.map(gama => {
          const newGama: any = { ...gama, order_id: new_order.id, order: new_order }
          delete newGama.id
          return newGama
        })

        this.sortOrders()
        
        for(let gama of duplicated_gamas){
          this.gamaService.createGama(gama).subscribe(
            new_gama => {
              new_order.gamas.push(new_gama)
            },
            error => {
              console.error('Error duplicating gama', error)
            }
          )
        }
      },
      error => {
        console.error('Error cloning order', error)
      }
    )
  }

  generateGamasPDF(order: OrderWithGamas){
    this.pdfService.saveAllOrderGamasPDF(order)
  }

  closeDeleteModal(){
    this.modal = false
    this.delete_order = {id: '', number: '', gamas: []}
    this.modal_delete_checkbox = false
  }

  openDeleteModal(order: OrderWithGamas){
    this.delete_order = order
    this.modal_delete_checkbox = false
    this.modal = true
  }

  deleteOrder(){
    this.orderService.deleteOrderById(this.delete_order.id).subscribe(
      () => {
        this.orders = this.orders.filter(order => order.id !== this.delete_order.id)
        this.delete_order = {id: '', number: '', gamas: []}
        this.modal_delete_checkbox = false
        this.closeDeleteModal()
      },
      error => {
        console.error('Error deleting order', error)
      }
    )
  }
}
